import { render, staticRenderFns } from "./PhotoDialog.vue?vue&type=template&id=15a8dfb7&"
import script from "./PhotoDialog.vue?vue&type=script&lang=js&"
export * from "./PhotoDialog.vue?vue&type=script&lang=js&"
import style0 from "./PhotoDialog.vue?vue&type=style&index=0&id=15a8dfb7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports